import {
  IFavoritedUser,
  IRemoveUserFavoritesRequest,
  ISetUserFavoritesRequest,
} from '@dataTypes/user-favorite.type'
import axios from './axiosConfig'
import { getEnv } from '@utils/env'
import { logger } from '@utils/safeLogger'
import { toApiError } from './errors/api-error'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_USER_FAVORITES')

const headers = {
  'Content-Type': 'application/json',
}

interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

type FavoritedUsersResponseData = {
  favorited_users?: IFavoritedUser[]
}

type AllMembersResponseData = {
  users?: IFavoritedUser[]
}

type GenericResponseData = Record<string, unknown>

export type GetFavoritedUsersResponse = ApiResponse<FavoritedUsersResponseData>
export type GetAllMembersResponse = ApiResponse<AllMembersResponseData>
export type UserFavoritesGenericResponse = ApiResponse<GenericResponseData>

export const getAllUsers = async (
  excludeUserId?: string,
): Promise<GetAllMembersResponse> => {
  try {
    const response = await axios.get<GetAllMembersResponse>(
      `${BUSINESS_LAYER_API}/api/v1/user-favorites/all-members`,
      {
        headers,
        params: excludeUserId ? { exclude_user_id: excludeUserId } : undefined,
      },
    )
    return response.data
  } catch (e: unknown) {
    logger.error('Error in getAllUsers:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const getFavoritedUsers = async (
  userId: string,
): Promise<GetFavoritedUsersResponse> => {
  try {
    const response = await axios.get<GetFavoritedUsersResponse>(
      `${BUSINESS_LAYER_API}/api/v1/user-favorites`,
      {
        headers,
        params: { user_id: userId },
      },
    )
    return response.data
  } catch (e: unknown) {
    logger.error('Error in getFavoritedUsers:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const createFavoritedUsers = async (
  payload: ISetUserFavoritesRequest,
): Promise<GetFavoritedUsersResponse> => {
  try {
    const response = await axios.put<GetFavoritedUsersResponse>(
      `${BUSINESS_LAYER_API}/api/v1/user-favorites`,
      payload,
      { headers },
    )
    return response.data
  } catch (e: unknown) {
    logger.error('Error in setFavoritedUsers:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const deleteFavoritedUsersByIds = async (
  payload: IRemoveUserFavoritesRequest,
): Promise<UserFavoritesGenericResponse> => {
  try {
    const response = await axios.delete<UserFavoritesGenericResponse>(
      `${BUSINESS_LAYER_API}/api/v1/user-favorites`,
      {
        headers,
        data: payload,
      },
    )
    return response.data
  } catch (e: unknown) {
    logger.error('Error in removeFavoritedUsers:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}
